import React from 'react';

import Link from '../../../../components/Link';

import styles from './styles.sass';

const ArrowLink = ({ href, text, onClick }) => {
  const splicedText = text.split(' ');
  const firstWords = splicedText.splice(0, splicedText.length - 1);
  return (
    <Link to={href} className={styles.ArrowLink} onClick={onClick}>
      <React.Fragment>
        {firstWords.join(' ')}{' '}
        <span className="noWrap">
          {splicedText}
          {` `}
          <span className={styles.arrow}>&#8594;</span>
        </span>
      </React.Fragment>
    </Link>
  );
};

export { ArrowLink };
